import PropTypes from 'prop-types';

import { SORT_DIRECTIONS } from '../../../constants';

export const SORT_COLUMN_PROP_TYPES = PropTypes.shape({
    name: PropTypes.string.isRequired,
    field: PropTypes.string.isRequired
});

export const SORT_DIRECTION_PROP_TYPES = PropTypes.oneOf([
    SORT_DIRECTIONS.ASC,
    SORT_DIRECTIONS.DESC
]);
